import Axios from "axios"
import { apiServerHost } from "./APIServerSettings"

// 개발 API flag
export const DEV_API_FLAG = false

// Unused
export const updateResponseMessage = (callBack, responseId, messages) => {
  const params = new URLSearchParams()
  params.append("responseID", responseId)
  params.append("messagesJSON", JSON.stringify(messages))

  Axios.post(apiServerHost+"/manage/topic/topicbuilder/update/response/response", params, {})
  .then(callBack)
}

export const getTopicListNotMyOwn = (callBack, error_callBack, args = null) => {
  Axios.post(apiServerHost+`/manage/topic/${DEV_API_FLAG ? "dev/" : ""}getTopicListByManagerNotMyOwn.do`)
  // Axios.post(apiServerHost+"/manage/topic/dev/getTopicListByManagerNotMyOwn.do")
  .catch(error_callBack)
  .then(response => {callBack(response, args)})
}